import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useCurrentPlanFeatures } from '@/hooks/useCurrentPlanFeatures';
import { RouteMap } from '@/routes/Routes';
import SilentErrorBoundary from '@/components/SilentErrorBoundary';
import { PageHeader, PAGE_MAX_WIDTH } from '@/components/Layout/PageLayout';
import DesktopApp from '@/pages/Settings/components/DesktopApp/DesktopApp';
import DesktopFeatureComparison from '@/pages/Settings/components/DesktopApp/DesktopFeatureComparison';

const DesktopAppPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { features, isLoading, error } = useCurrentPlanFeatures();

  // Wait for pricing data before deciding — features default to false while it
  // loads, which would bounce an entitled user straight back to Settings.
  // A failed pricing fetch also leaves every feature false. Redirecting on that
  // would silently throw an entitled user out; let the section render its own
  // unavailable message instead. Only a resolved "not entitled" redirects, and
  // since the nav link is plan-gated that only catches a direct URL hit.
  if (!isLoading && !error && features.desktopDownload !== true) {
    return <Navigate to={RouteMap.SETTINGS} replace />;
  }

  return (
    <Box px={isMobile ? '16px' : '32px'} py={3}>
      <Box maxWidth={PAGE_MAX_WIDTH}>
        <PageHeader title="Desktop App" subtitle="Record from your desktop without the browser extension." />
        {/* Shows its own loading card until pricing and downloads settle, so it
            renders straight away rather than remounting once pricing lands. */}
        <DesktopApp />
        {/* Informational only — a throw here must not take the downloads with it. */}
        {!isLoading && (
          <SilentErrorBoundary feature="settings" operation="desktopFeatureComparison">
            <DesktopFeatureComparison />
          </SilentErrorBoundary>
        )}
      </Box>
    </Box>
  );
};

export default DesktopAppPage;
